import api from './api';

class CategoryService {
  /**
   * Get paginated list of categories
   * @param {number} page - Page number (0-based)
   * @param {number} size - Page size
   * @param {string} search - Search query
   * @param {boolean|string} status - Filter by status (true/false or empty string for all)
   * @returns {Promise} API response
   */
  async getCategories(page = 0, size = 10, search = '', status = '') {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
      });
      
      if (search?.trim()) {
        params.append('search', search.trim());
      }

      if (status !== '') {
        params.append('status', status.toString());
      }

      const response = await api.get(`/admin/categories?${params}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get category by ID
   * @param {number} id - Category ID
   * @returns {Promise} API response
   */
  async getCategory(id) {
    try {
      const response = await api.get(`/admin/categories/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get category with statistics
   * @param {number} id - Category ID
   * @returns {Promise} API response
   */
  async getCategoryWithStats(id) {
    try {
      const response = await api.get(`/admin/categories/${id}/stats`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Create new category
   * @param {Object} data - Category data
   * @returns {Promise} API response
   */
  async createCategory(data) {
    try {
      const response = await api.post('/admin/categories', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Update category
   * @param {number} id - Category ID
   * @param {Object} data - Category data
   * @returns {Promise} API response
   */
  async updateCategory(id, data) {
    try {
      const payload = { ...data, id };
      const response = await api.put(`/admin/categories/${id}`, payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Delete category
   * @param {number} id - Category ID
   * @returns {Promise} API response
   */
  async deleteCategory(id) {
    try {
      const response = await api.delete(`/admin/categories/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get all categories for dropdown (without pagination)
   * @returns {Promise} API response
   */
  async getAllCategories() {
    try {
      const response = await api.get('/admin/categories?size=1000');
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

const categoryService = new CategoryService();
export default categoryService;